import { __assign } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import LoadingMask from "@/components/GlobalMask/LoadingMask.vue";
import SmallLoading from "@/components/common/SmallLoading.vue";
import Live2DCanvas from "@/components/live2d/Live2D.vue";
import { generate } from "@ant-design/colors";
import { useNotification, useDialog, useMessage, NAlert } from "naive-ui";
import { useStore } from "@/store";
import { h } from "vue";
import { useRoute } from "vue-router";
import { phraseInit } from "@/utils/phrase";
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup: function (__props) {
        phraseInit(); // 初始化编辑都会用到的 phrase
        var store = useStore();
        var route = useRoute();
        window.$notification = useNotification();
        window.$dialog = useDialog();
        window.$message = useMessage();
        // 自定义 notification、message 四个函数样式
        // notification 统一样式组合
        var notifyStyle = {
            duration: 5000,
            keepAliveOnHover: true,
        };
        var notifyTemplate = function (title, content, type) {
            return window.$notification.create(__assign({
                title: title,
                content: content,
                type: type,
            }, notifyStyle));
        };
        window.$notifyInfo = function (title, content) {
            console.log("NOTIFICATION INFO: \n", title, content);
            return notifyTemplate(title, content, "info");
        };
        window.$notifySuccess = function (title, content) {
            console.log("NOTIFICATION SUCCESS: \n", title, content);
            return notifyTemplate(title, content, "success");
        };
        window.$notifyError = function (title, content) {
            console.log("NOTIFICATION ERROR: \n", title, content);
            return notifyTemplate(title, content, "error");
        };
        window.$notifyWarning = function (title, content) {
            console.log("NOTIFICATION WARNING: \n", title, content);
            return notifyTemplate(title, content, "warning");
        };
        // message 统一样式组合
        // 废弃，使用默认样式
        function msgRender(color, msg) {
            var colorSet = generate(color);
            return function (props) {
                return h(NAlert, {
                    closable: props.closable,
                    onClose: props.onClose,
                    type: props.type === "loading" ? "default" : props.type,
                    title: "你看你手上拿的是什么啊",
                    style: {
                        boxShadow: "var(--n-box-shadow)",
                        maxWidth: "calc(100vw - 32px)",
                        width: "480px",
                    },
                }, {
                    default: function () { return props.content; },
                });
            };
        }
        var messageStyle = {
            duration: 5000,
            keepAliveOnHover: true,
        };
        window.$msgInfo = function (content) {
            return window.$message.info(content, __assign({}, messageStyle));
        };
        window.$msgSuccess = function (content) {
            return window.$message.success(content, __assign({}, messageStyle));
        };
        window.$msgError = function (content) {
            return window.$message.error(content, __assign({}, messageStyle));
        };
        window.$msgWarning = function (content) {
            return window.$message.warning(content, __assign({}, messageStyle));
        };
        return function (_ctx, _cache) {
            var _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "process-parent" }, null, -1)),
                _createVNode(LoadingMask),
                _createVNode(SmallLoading),
                (_unref(store).isShowLive2d)
                    ? (_openBlock(), _createBlock(Live2DCanvas, {
                        key: 0,
                        class: "live2d-canvas"
                    }))
                    : _createCommentVNode("", true),
                (_openBlock(), _createBlock(_component_router_view, {
                    key: _unref(route).path
                }))
            ], 64));
        };
    }
});
